<div class="resource-configure mb-24">
 <div class="pl-4 pr-4 pt-24 flex flex-col">
    <div class="flex items-center steper-section mb-16">
      <div class="flex items-center justify-center" [ngClass]="{'current-tab': isCurrent(tbc), 'visited': isVisited(tbc)}">
        <span class="flex items-center justify-center mr-8"><span class="mat-subtitle-2 fw-700 fs-14 count flex items-center justify-center">1</span></span>
        <span class="mat-subtitle-2 fw-500 tab-name">{{ 'INSTANCE_DETAILS.RESOURCE_CONFIGURATION.PRODUCT_CONFIGURATION' | transloco }}</span>
        <span class="horizontal-line ml-12"></span>
      </div>
      <div class="flex items-center justify-center" [ngClass]="{'current-tab': isCurrent(exchange), 'visited': isVisited(exchange)}">
        <span class="flex items-center justify-center mr-8"><span class="mat-subtitle-2 fw-700 fs-14 count flex items-center justify-center">2</span></span>
        <span class="mat-subtitle-2 fw-500 tab-name">{{ 'INSTANCE_DETAILS.RESOURCE_CONFIGURATION.EXCHANGE_CONFIGURATION' | transloco }}</span>
        <span class="horizontal-line ml-12"></span>
      </div>
      <div class="flex items-center justify-center" [ngClass]="{'current-tab': isCurrent(review)}">
        <span class="flex items-center justify-center mr-8"><span class="mat-subtitle-2 fw-700 fs-14 count flex items-center justify-center">3</span></span>
        <span class="mat-subtitle-2 fw-500 tab-name">{{ 'INSTANCE_DETAILS.RESOURCE_CONFIGURATION.SUMMARY' | transloco }}</span>
      </div>
    </div>

    <mat-divider class="neutral-2"></mat-divider>
    <div class="tab-header mb-16 mt-16">
      <div *ngIf="activePage === tbc" class="flex flex-row tabs-section">
        <mat-tab-group>
          <mat-tab>
            <ng-template mat-tab-label>
              <div *ngFor="let tbcData of tbcComponents; let last = last" class="mat-subtitle-1 fw-500 fs-16 mb-0 items-center tabs h-40" [ngClass]="{'active fw-700': tbcData.active, 'edited': (tbcData?.form && tbcData?.form[0]?.formGroup.touched)}" (click)="getComponent(tbcData , tbc)">{{tbcData.displayName ? tbcData.displayName : tbcData.name}}<span *ngIf="!last" class="separator ml-16"></span></div>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>

      <div *ngIf="activePage === exchange" class="flex flex-row tabs-section">
        <mat-tab-group>
          <mat-tab>
            <ng-template mat-tab-label>
              <div *ngFor="let exchangeData of exchangeComponents; let last = last" class="mat-subtitle-1 fw-500 fs-16 mb-0 flex items-center tabs h-40" [ngClass]="{'active fw-700': exchangeData.active, 'edited': (exchangeData?.form && exchangeData?.form[0]?.formGroup.touched)}" (click)="getComponent(exchangeData , exchange)">{{exchangeData.displayName ? exchangeData.displayName : exchangeData.name}}<span *ngIf="!last">|</span></div>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
    <div *ngIf="isComponentLoaded && (activePage === tbc && tbcComponents?.length === 0) || (activePage === exchange && exchangeComponents?.length === 0)" class="flex items-center justify-center pt-64 pb-64 flex-col no-data">
      <img src="/assets/images/no-data.png">
      <div>{{activePage === tbc ? ('INSTANCE_LIST.PRODUCT_PARAMETERS_NOT_AVAILABLE' | transloco) : ('INSTANCE_LIST.EXCHANGE_PARAMETERS_NOT_AVAILABLE' | transloco)}}</div>
    </div>
  </div>
  <div class="flex flex-col pl-4 pr-4" *ngIf="(activePage === tbc && tbcComponents?.length > 0) || (activePage === exchange && exchangeComponents?.length > 0) || activePage === review">
    <div *ngIf="installationSpecificationForms?.length && activeForm && activePage === tbc || activePage === exchange; else noDataFound" class="ques-section p-24">
      <ng-container *ngIf="installationSpecificationForms?.length && activeForm && activePage === tbc || activePage === exchange; else noDataFound">
        <app-dynamic-form *ngFor="let installationSpecificationForm of installationSpecificationForms" [dynamicFormModel]="installationSpecificationForm">
        </app-dynamic-form>  
      </ng-container>
    </div>
    <ng-template #noDataFound>
      <div *ngIf="activePage !== review && isComponentLoaded" class="flex items-center justify-center pt-64 pb-64 flex-col no-data">
        <img src="/assets/images/no-data.png">
        <div>{{activePage === tbc ? ('INSTANCE_LIST.PRODUCT_PARAMETERS_NOT_AVAILABLE' | transloco) : ('INSTANCE_LIST.EXCHANGE_PARAMETERS_NOT_AVAILABLE' | transloco)}}</div>
      </div>
    </ng-template> 
    <div *ngIf="activePage === review">
      <ng-container *ngIf="tbcComponents?.length">
        <div class="flex flex-col sumary-section mb-16 section-border p-16">
          <div class="flex flex-row justify-between mb-20">
            <div class="mat-subtitle-1 fs-16 fw-700 sub-header mb-0">
              {{ 'INSTANCE_DETAILS.RESOURCE_CONFIGURATION.PRODUCT_CONFIGURATION' | transloco }}
            </div>

          <div class="flex justify-end cursor-pointer edit" (click)="onEdit('tbc')">
            <mat-icon svgIcon="edit" class="h-16 w-16 mr-4 mt--2"></mat-icon>
              <div class="fs-16 fw-500 mt--4">
                {{ 'BUTTONS.EDIT' | transloco }}
              </div>
          </div>
        </div>

          <div *ngFor="let tbcReview of tbcComponents" class="component-data mat-subtitle-2 mb-16 word-break-word">
            <div class="component-name overline-font subheading fs-14 mb-16">
              {{ tbcReview?.displayName || tbcReview?.name }}
            </div>

            <ng-container *ngFor="let formData of tbcReview.form">
              <app-questionnaire-summary [dynamicFormModel]="formData"></app-questionnaire-summary>
            </ng-container>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="exchangeComponents?.length">
        <div class="flex flex-col sumary-section mb-16 section-border p-16">
          <div class="flex flex-row justify-between mb-20">
            <div class="mat-subtitle-1 fs-16 fw-700 sub-header mb-0">
              {{ 'INSTANCE_DETAILS.RESOURCE_CONFIGURATION.EXCHANGE_CONFIGURATION' | transloco }}
            </div>

            <div class="flex justify-end cursor-pointer edit" (click)="onEdit('exchange')">
              <mat-icon svgIcon="edit" class="h-16 w-16 mr-4 mt--2"></mat-icon>
            <div class="fs-16 fw-500 mt--4">
                {{ 'BUTTONS.EDIT' | transloco }}
            </div>
          </div>
        </div>

            <div *ngFor="let exchangeReview of exchangeComponents" class="component-data mat-subtitle-2 mb-16 word-break-word">
              <div class="component-name overline-font subheading fs-14 mb-16">
                {{ exchangeReview?.displayName || exchangeReview?.name }}
              </div>

            <ng-container *ngFor="let formData of exchangeReview.form">
              <app-questionnaire-summary [dynamicFormModel]="formData"></app-questionnaire-summary>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
<div class="deploy-footer">
  <div class="footer-divider"></div>
    <div class="footer-actions">
      <div class="flex justify-items-center items-center prev-btn fs-16 fw-700 mr-24 pr-4 pl-16 pt-4 pb-8" *ngIf="activePage !== tbc">
        <mat-icon (click)="previous(activePage)" class="icon-sm cursor-pointer mr-8" svgIcon="arrow_back"></mat-icon>
          {{ 'BUTTONS.PREVIOUS' | transloco }}
     </div>
        <button class="flex justify-items-center items-center cancel-btn mr-4 pr-16 pl-16 pt-8 pb-8" (click)="goBack()">{{ 'BUTTONS.CANCEL' | transloco }}</button>
        <button *ngIf="activePage !== review" (click)="continue(activePage)" class="flex justify-items-center spacing items-center mossgreen primary-fg pr-16 pl-16 pt-8 pb-8">{{ 'BUTTONS.NEXT' | transloco }}</button>
        <button *ngIf="activePage === review" (click)="continue(activePage)" class="flex justify-items-center spacing items-center mossgreen primary-fg pr-16 pl-16 pt-8 pb-8" type="button">{{ 'BUTTONS.SUBMIT' | transloco }}</button>
      </div>
</div>